/**
 * Màu theo hạng gói, dùng chung cho thẻ tier lúc bán và thẻ package của khách lúc dùng.
 * Giữ một bảng màu duy nhất để hai luồng không lệch nhau.
 */
export type PackageThemeKey = 'bronze' | 'silver' | 'gold';

export const PACKAGE_THEME_COLORS: Record<PackageThemeKey, { main: string; contrastText: string }> = {
  bronze: { main: '#C84B31', contrastText: '#FFFFFF' },
  silver: { main: '#64748B', contrastText: '#FFFFFF' },
  gold: { main: '#EBA33B', contrastText: '#FFFFFF' },
};

const THEME_BY_TYPE: Record<string, PackageThemeKey> = {
  BRONZE: 'bronze',
  SILVER: 'silver',
  GOLD: 'gold',
};

/** type lạ hoặc thiếu thì về bronze, thà sai màu còn hơn vỡ UI */
export const getPackageThemeByType = (type?: string | null): PackageThemeKey =>
  THEME_BY_TYPE[(type || '').toUpperCase()] || 'bronze';
